import axios from 'axios'
import store from '@/store'

const http = axios.create({
    baseURL: `/api/`,
    withCredentials: false,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    }
})


http.interceptors.request.use(function (config) {
    return store.dispatch('oidcStore/getOidcUser').then(user => {
        config.headers = {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+ user.access_token
        }
        return config
    })
})


http.interceptors.response.use(
    response => {
        if (response && response.config && response.config.successMsg) {
            store.dispatch('success', response.config.successMsg)
        }
        return response
    },
    error => {
        if (error && !error.response) {
            store.dispatch('error', 'Network connection problem')
            return Promise.reject(error)
        }

        if (error.response.status === 400) {
            if(error.response.data && error.response.data.message && error.response.data.message.includes('unique constraint')) {
                store.dispatch('error', 'Invalid request content: Duplicate value')
            } else {
                store.dispatch('error', 'Invalid request content')
            }
        }

        if (error.response.status === 403) {
            store.dispatch('error', 'You don\'t have permission to access the requested resource')
        }

        if (error.response.status === 500 || error.response.status === 504) {
            if(error.response && error.response.data.message) {
                store.dispatch('error', error.response.data.message)
            } else {
                store.dispatch('error', error.toString())
            }

        }
        return Promise.reject(error)
    }
)

export default http
